<template src="./EstatisticasAcesso.html"></template>
<style src="./EstatisticasAcesso.css">
</style>

<script>

import Filter from "@/components/EstatisticasAcesso/Filter/Filter";

import store from "@/store";

export default {
    components: {
        "estatistica-acesso-content": Filter
    },
    data() {
        return {
            items: ["Click Me", "Click Me", "Click Me", "Click Me 2"]
        };
    },
    methods: {
        onResize() {
            store.dispatch("setWindowWidth", window.innerWidth);
            store.dispatch("setWindowHeight", window.innerHeight);
        }
    },
    computed: {
        snackBar() {
            return store.state.comandosValidacaoLog.snackBar;
        }
    }
};
</script>